<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <span style="font-size: 14px;font-weight: bold;margin-left: 10%;margin-bottom: 10px">维度</span><span style="font-size: 14px;font-weight: bold;margin-left: 15%;margin-bottom: 10px">分值</span>
      <el-row v-for="(type,index) in examineTypeList"  :key="type.id"  >
      <el-form-item label="" prop="examineTypeId">
        <!--<el-select v-model="dataForm.examineTypeId" placeholder="请选择" clearable>
          <el-option v-for="examineType in examineTypeList" :label="examineType.examineTypeName" :value="examineType.id"
                     :key="examineType.id" ></el-option>
        </el-select>-->
        <el-checkbox-group v-model="dataForm.type" >
          <el-checkbox :label="type.id" name="type">{{type.examineTypeName}}</el-checkbox>
          <el-input style="width: 100px;margin-left: 100px" @change="getdata($event,type.id,index)" v-model="dataForm.scoreSets[type.id]" placeholder="分数设置"></el-input>
        </el-checkbox-group>
      </el-form-item>
      </el-row>
      <span style="color: red">注：扣分大于等于设置的分值该维度不得星</span>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  components: { },
  data () {
    return {
      visible: false,
      schoolVisible: false,
      schoolList: [],
      examineTypeList: [],
      dataForm: {
        id: '',
        scoreSet: '',
        scoreSets: [],
        examineTypeId: '',
        examineTypeName: '',
        creator: '',
        updater: '',
        createDate: '',
        updateDate: '',
        scoreMap: [],
        type: [],
        schoolId: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.getSchoolList()
      this.getExamineTypeList()
      this.dataForm.scoreSets = []
      this.dataForm.type = []
      this.dataForm.scoreMap = []
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        this.resetValue()
        this.getInfo()
      })
    },
    getdata (score, eid, index) {
      const r = /^[+-]?(0|([1-9]\d*))(\.\d{1})?$/
      if (this.dataForm.scoreSets != null) {
        if (!r.test(score)) {
          var Pics = this.dataForm.scoreSets
          Pics.forEach((item, index) => {
            Pics.splice(index, 1)
          })
          return this.$message.error('最多支持小数点后一位')
        }
      }
      const params = {
        val: score,
        key: eid
      }
      // map.set(e, num)
      for (let i = 0; this.dataForm.scoreMap.length > i; i++) {
        if (this.dataForm.scoreMap[i].key === eid) {
          this.dataForm.scoreMap[i] = params
        }
      }

      console.log(this.dataForm)
    },
    resetValue () {
      this.dataForm.schoolId = ''
      this.schoolVisible = false
    },
    // 获取学校的集合
    getSchoolList () {
      this.$http.get('/school/school/getSchoolList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.schoolList = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取类型集合
    getExamineTypeList () {
      this.$http.post(`classEvaluate/examineType/getExamineTypeList?schoolId=${this.dataForm.schoolId}`).then(({ data: res }) => {
        if (res.code !== 0) {
          if (res.code === 10050) {
            this.schoolVisible = true
            this.getSchoolList()
          }
          return this.$message.error(res.msg)
        }
        this.examineTypeList = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get('/classEvaluate/starRule/getRule').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      // this.dataForm.examineTypeName = this.examineTypeList.filter((e) => { return e.id === this.dataForm.examineTypeId })[0].examineTypeName
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/classEvaluate/starRule/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { leading: true, trailing: false })
  }
}
</script>
